<div
  class="flex"
  [class.flex-col]="arrowCssClass() === 'bottom' || arrowCssClass() === 'top'"
  [class.items-center]="arrowCssClass() === 'start' || arrowCssClass() === 'end'"
>
  <!-- Bottom arrow -->
  @if (arrowCssClass() === 'bottom') {
    <div
      class="h-0 w-0 border-x-[6px] border-b-[6px] border-x-transparent"
      [class.border-primary-600]="data.variant === 'info'"
      [class.border-error-500]="data.variant === 'error'"
      [class.border-warning-500]="data.variant === 'warning'"
      [class.border-success-600]="data.variant === 'success'"
      [style.translate]="translateX()"
    ></div>
  }

  <!-- Right arrow -->
  @if (arrowCssClass() === 'end') {
    <div
      class="h-0 w-0 translate-x-[3px] -rotate-90 border-x-[6px] border-b-[6px] border-x-transparent"
      [class.border-primary-600]="data.variant === 'info'"
      [class.border-error-500]="data.variant === 'error'"
      [class.border-warning-500]="data.variant === 'warning'"
      [class.border-success-600]="data.variant === 'success'"
    ></div>
  }

  <!-- Content -->
  <div
    class="relative block min-w-[228px] max-w-min whitespace-pre-line rounded p-3 text-normal sm:max-w-none sm:grow sm:bg-neutral-000 sm:p-0 sm:shadow-default"
    [class.bg-primary-600]="data.variant === 'info'"
    [class.bg-error-500]="data.variant === 'error'"
    [class.bg-warning-500]="data.variant === 'warning'"
    [class.bg-success-600]="data.variant === 'success'"
    [ngClass]="classes()"
  >
    <div>
      @if (data.title && isMobile()) {
        <div class="rounded-t bg-neutral-300 p-4 text-2xl font-bold text-text-700">
          {{ data.title }}
        </div>
      }
      <div
        class="text-left text-normal sm:border-b-2 sm:border-neutral-500 sm:p-4 sm:pb-6 sm:text-text-700"
        [class.text-text-000]="data.variant === 'info' || data.variant === 'error' || data.variant === 'success'"
        [class.text-text-700]="data.variant === 'warning'"
        [class.dark:text-text-700]="data.variant === 'info'"
        [class.dark:text-text-000]="data.variant === 'warning' || data.variant === 'success' || data.variant === 'error'"
        [class.dark:sm:text-text-700]="data.variant === 'warning' || data.variant === 'success' || data.variant === 'error'"
      >
        @if (isTemplate(data.tooltip)) {
          <ng-container [ngTemplateOutlet]="data.tooltip" />
        } @else {
          <div [innerHTML]="data.tooltip"></div>
        }
      </div>

      @if (isMobile()) {
        <div class="p-4 pt-6">
          <app-button
            size="big"
            [isBlock]="true"
            type="secondary"
            [label]="'shared.tooltip.close' | translate"
            (clicked)="closeTooltip()"
          />
        </div>
      }
    </div>
  </div>

  <!-- Top arrow -->
  @if (arrowCssClass() === 'top') {
    <div
      class="h-0 w-0 rotate-180 border-x-[6px] border-b-[6px] border-x-transparent"
      [class.border-primary-600]="data.variant === 'info'"
      [class.border-error-500]="data.variant === 'error'"
      [class.border-warning-500]="data.variant === 'warning'"
      [class.border-success-600]="data.variant === 'success'"
      [style.translate]="translateX()"
    ></div>
  }

  <!-- Left arrow -->
  @if (arrowCssClass() === 'start') {
    <div
      class="h-0 w-0 -translate-x-[3px] rotate-90 border-x-[6px] border-b-[6px] border-x-transparent"
      [class.border-primary-600]="data.variant === 'info'"
      [class.border-error-500]="data.variant === 'error'"
      [class.border-warning-500]="data.variant === 'warning'"
      [class.border-success-600]="data.variant === 'success'"
    ></div>
  }
</div>
